module.exports = __webpack_public_path__ + "img/Ensemble_rules_2026.52c1e645.png";